export default {
  setUser(state, payload) {
    state.user = payload;
  },
  setUserCredentials(state, payload) {
    state.user.credentials = payload;
  }
};
